var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFigma(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "figma",
    xmlns: "http://www.w3.org/2000/svg",
    width: 38.738,
    height: 58.107,
    viewBox: "0 0 38.738 58.107",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M9.684,219.369a9.688,9.688,0,0,0,9.684-9.684V200H9.684a9.684,9.684,0,0,0,0,19.369Z",
    transform: "translate(0 -161.262)",
    fill: "#0acf83"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M0,109.684A9.688,9.688,0,0,1,9.684,100h9.684v19.369H9.684A9.688,9.688,0,0,1,0,109.684Z",
    transform: "translate(0 -80.631)",
    fill: "#a259ff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M0,9.684A9.688,9.688,0,0,1,9.684,0h9.684V19.369H9.684A9.688,9.688,0,0,1,0,9.684Z",
    fill: "#f24e1e"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M100,0h9.684a9.684,9.684,0,0,1,0,19.369H100Z",
    transform: "translate(-80.631)",
    fill: "#ff7262"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M119.369,109.684A9.684,9.684,0,1,1,109.684,100,9.688,9.688,0,0,1,119.369,109.684Z",
    transform: "translate(-80.631 -80.631)",
    fill: "#1abcfe"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigma);
export default __webpack_public_path__ + "static/media/figma.b9ae66893b63dbfbaec62d059dbc1dfa.svg";
export { ForwardRef as ReactComponent };